<script lang="ts" setup>
import Swal from "sweetalert2";
const newsStore = useNewsStore();
// import { useUserStore } from '~/stores/user';

const config = useRuntimeConfig()
const userStore = useUserStore();
const jml_news = ref();
const dropdowns = ref({
  transportasi: false,
  pesawat: false,
  kereta: false,
  pelni: false,
});

const show_markup = userStore.config_user?.settings?.show_markup || true;

const logoutConfirm = () => {
  Swal.fire({
    title: "Yakin ingin logout?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Yes",
  }).then((result) => {
    if (result.isConfirmed) {
      signOut();
    }
  });
};
const state = reactive({
  logoutInProgress: false,
});

const signOut = async () => {
  if (!state.logoutInProgress) {
    state.logoutInProgress = true;

    try {
      const response = await userStore.logout();

      if(response.status.code === 200) {
        navigateTo("/");
        Swal.fire({
          title: "Logout Berhasil",
          icon: "success",
        });
      }else{
        Swal.fire({
          title: "Logout Gagal",
          icon: "error",
        });
      }
      // useRouter().go(0);

      // Pengalihan halaman setelah logout
    } catch (error) {
      console.error("Gagal logout:", error);
    } finally {
      state.logoutInProgress = false;
    }
  }
};

const clearCache = () => {
  Swal.fire({
    title: "Hapus Cache?",
    text: "Semua cache, cookie, dan penyimpanan lokal (termasuk data login) akan dihapus. Anda juga akan otomatis logout dan halaman akan dimuat ulang.",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Ya, Hapus Semua!",
  }).then((result) => {
    if (result.isConfirmed) {
      if ('caches' in window) {
        caches.keys().then(names => {
          names.forEach(name => caches.delete(name));
        });
      }

      document.cookie.split(";").forEach(cookie => {
        const name = cookie.split("=")[0].trim();
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
      });

      localStorage.clear();
      sessionStorage.clear();


      location.reload();
    }
  });
};

const news = async() => {
  const response: any = await newsStore.countNews();
  jml_news.value = response;
}

const getCurrentSaldo = async () => {
  const response: any = await userStore.fetchUserBalance();
};

const toggleDropdown = (menu) => {
  // Close other dropdowns if they are open
  Object.keys(dropdowns.value).forEach((key) => {
    if (key !== menu) {
      dropdowns.value[key] = false; // Close other dropdowns
    }
  });
  // Toggle the clicked dropdown
  dropdowns.value[menu] = !dropdowns.value[menu];
};

onMounted(() => {
  watch(() => userStore.token, (newToken) => {
    if (newToken) {
      news();
      getCurrentSaldo()
    }
  }, { immediate: true })
})
</script>
<template>
  <div class="sticky-top">
    <!-- Header -->
    <header class="bg-primary">
      <div>
        <hr class="border mt-0 mb-0 border-white border-3" />
      </div>
    </header>
    <!-- End Header -->

    <!-- Navbar -->
    <nav class="navbar bg-white navbar-expand-lg shadow">
      <div class="container">
        <NuxtLink to="/" class="navbar-brand">
          <img :src='`${config.public.logoNav}`' alt="logo" />
        </NuxtLink>
        <button
          class="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>

        <div
          class="collapse navbar-collapse"
          id="navbarSupportedContent"
        >
          <ul class="navbar-nav ms-auto fw-bolder">
            <li class="nav-item dropdown">
              <a
                class="nav-link dropdown-toggle"
                href="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Transportasi
              </a>
              <ul class="dropdown-menu rounded-2 border border-0 shadow" :class="{ show: dropdowns.transportasi }">
                <li class="dropend" @click.stop="toggleDropdown('pesawat')">
                  <a class="dropdown-item dropdown-toggle" href="#"><i class="fas fa-plane text-primary"></i> Pesawat</a>
                  <ul class="dropdown-menu rounded-2 border border-0 shadow" :class="{ show: dropdowns.pesawat }">
                    <li>
                      <NuxtLink class="dropdown-item" to="/airlines/">Transaksi Pesawat</NuxtLink>
                    </li>
                    <li v-if="userStore.token">
                      <NuxtLink class="dropdown-item" to="/airlines/reports">Data Transaksi</NuxtLink>
                    </li>
                    <li v-if="userStore.token">
                      <NuxtLink class="dropdown-item" to="/airlines/refund-reports">Laporan Refund</NuxtLink>
                    </li>
                    <li v-if="userStore.token">
                      <NuxtLink class="dropdown-item" to="/airlines/rebook-reports">Laporan Rebook</NuxtLink>
                    </li>
                    <li v-if="userStore.token">
                      <NuxtLink class="dropdown-item" to="/airlines/web_checkin">Web Check In</NuxtLink>
                    </li>
                  </ul>
                </li>

                <li class="dropend" @click.stop="toggleDropdown('kereta')">
                  <a class="dropdown-item dropdown-toggle" href="#"><i class="fas fa-train text-success pe-2"></i> Kereta Api</a>
                  <ul class="dropdown-menu rounded-2 border border-0 shadow" :class="{ show: dropdowns.kereta }">
                    <li>
                      <NuxtLink class="dropdown-item" to="/trains">Transaksi Kereta Api</NuxtLink>
                    </li>
                    <li v-if="userStore.token">
                      <NuxtLink class="dropdown-item" to="/trains/reports">Data Transaksi</NuxtLink>
                    </li>
                  </ul>
                </li>

                <li class="dropend" @click.stop="toggleDropdown('pelni')">
                  <a class="dropdown-item dropdown-toggle" href="#"><i class="fas fa-ship text-primary-emphasis"></i> Pelni</a>
                  <ul class="dropdown-menu rounded-2 border border-0 shadow" :class="{ show: dropdowns.pelni }">
                    <li>
                      <NuxtLink class="dropdown-item" to="/pelni">Transaksi Pelni</NuxtLink>
                    </li>
                    <li v-if="userStore.token">
                      <NuxtLink class="dropdown-item" to="/pelni/reports">Data Transaksi</NuxtLink>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
            <li class="nav-item dropdown">
              <a
                class="nav-link dropdown-toggle"
                href="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Hotel
              </a>
              <ul class="dropdown-menu rounded-2 border border-0 shadow">
                <li>
                  <NuxtLink class="dropdown-item" to="/hotels"
                    ><i class="fas fa-hotel text-danger"></i> Hotel</NuxtLink
                  >
                </li>
                <li v-if="userStore.token">
                  <NuxtLink class="dropdown-item" to="/hotels/reports"
                    ><i class="fas fa-list-alt text-primary"></i> Data
                    Pesanan</NuxtLink
                  >
                </li>
              </ul>
            </li>
            <li class="nav-item dropdown">
              <a
                class="nav-link dropdown-toggle"
                href="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
              Pulsa dan Tagihan
              </a>
              <ul class="dropdown-menu rounded-2 border border-0 shadow">
                <li>
                  <NuxtLink class="dropdown-item" to="/ppob"
                    ><i class="fas fa-money-bills text-success-emphasis"></i>
                    Pulsa Tagihan</NuxtLink
                  >
                </li>
                <li v-if="userStore.token">
                  <NuxtLink class="dropdown-item" to="/ppob/reports">
                    <i class="fas fa-list-alt text-primary"></i> Data Transaksi
                  </NuxtLink>
                </li>
              </ul>
            </li>
            <li class="nav-item dropdown"  v-if="userStore.token && userStore.user?.type != 'Operasional'">
              <a
                class="nav-link dropdown-toggle"
                href="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Deposit
              </a>
              <ul class="dropdown-menu rounded-2 border border-0 shadow">
                <li v-if="userStore.token">
                  <NuxtLink class="dropdown-item" to="/deposits/histories"
                    ><i class="fas fa-book text-warning"></i>
                    Buku Saldo</NuxtLink
                  >
                </li>
                <li>
                  <NuxtLink class="dropdown-item" to="/deposits/tickets/"
                    ><i class="fas fa-money-bills text-success-emphasis"></i>
                    Topup Deposit</NuxtLink
                  >
                </li>
                <li v-if="userStore.token">
                  <NuxtLink class="dropdown-item" to="/deposits/tickets/histories">
                    <i class="fas fa-list-alt text-primary"></i> Data Topup
                  </NuxtLink>
                </li>
              </ul>
            </li>
            <li class="nav-item dropdown" v-if="userStore.token && userStore.user?.role === 'agld'">
              <a
                class="nav-link dropdown-toggle"
                href="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Sub Agen
              </a>
              <ul class="dropdown-menu rounded-2 border border-0 shadow">
                <li>
                  <NuxtLink class="dropdown-item" to="/users/subreseller"
                    ><i class="fas fa-user text-success-emphasis"></i>
                    Data Sub Agent</NuxtLink
                  >
                </li>
                <li class="dropend">
                  <a class="dropdown-item dropdown-toggle" href="#"
                    ><i class="fas fa-list-alt text-primary"></i> Data Tansaksi</a
                  >
                  <ul class="dropdown-menu rounded-2 border border-0 shadow">
                    <li>
                      <NuxtLink class="dropdown-item" to="/users/sub/reports/airlines">
                        Transaksi Pesawat
                      </NuxtLink>
                    </li>
                    <li>
                      <NuxtLink
                        class="dropdown-item"
                        to="/users/sub/reports/train"
                      >
                        Transaksi Kereta Api
                      </NuxtLink>
                    </li>
                    <li>
                      <NuxtLink
                        class="dropdown-item"
                        to="/users/sub/reports/pelni"
                      >
                       Transaksi Pelni
                      </NuxtLink>
                    </li>
                    <li>
                      <NuxtLink
                        class="dropdown-item"
                        to="/users/sub/reports/hotel"
                      >
                        Transaksi Hotel
                      </NuxtLink>
                    </li>
                    <li>
                      <NuxtLink
                        class="dropdown-item"
                        to="/users/sub/reports/ppob"
                      >
                       Transaksi Pulsa & PPOB
                      </NuxtLink>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
            <!-- <li class="nav-item">
              <NuxtLink to="/policy" class="nav-link" >Syarat & Ketentuan</NuxtLink>
            </li> -->
          </ul>
          <ul class="navbar-nav ms-auto align-items-center">
            <li class="nav-item" v-if="userStore.token">
              <NuxtLink to="/news" class="nav-link" style="color: #114777">
                <i class="fa-solid fa-book"></i> Berita
                <span class="top-0 start-100 translate-middle badge rounded-pill bg-danger">{{ jml_news }}</span>
              </NuxtLink>
            </li>
            <li class="nav-item">
              <div v-if="!userStore.token">
                <button
                  data-bs-toggle="modal"
                  data-bs-target="#ModalLoginForm"
                  id="btn-modal-login"
                  style="background-color: #dee2e6; color: #114777"
                  class="btn rounded btn-sm mt-1 fw-bold"
                >
                  <i class="fa-solid fa-circle-user"></i> Login
                </button>
              </div>
              <div class="dropdown" v-if="userStore.token">
                <a
                  class="btn rounded btn-sm mt-1 btn-profile fw-bold dropdown-toggle"
                  style="background-color: #dee2e6; color: #114777"
                  href="#"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i class="fa-solid fa-circle-user"></i>
                  {{ userStore.user?.name }}<br>
                  <label class="fw-light">
                    {{
                      !isNaN(parseFloat(userStore.currentSaldo)) && userStore.currentSaldo !== null && userStore.currentSaldo !== ''
                        ? parseFloat(userStore.currentSaldo).toLocaleString("id-ID", {
                            style: "currency",
                            currency: "IDR",
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0
                          })
                        : !isNaN(parseFloat(userStore.user?.deposit)) && userStore.user?.deposit !== null && userStore.user?.deposit !== ''
                          ? parseFloat(userStore.user.deposit).toLocaleString("id-ID", {
                              style: "currency",
                              currency: "IDR",
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 0
                            })
                          : (0).toLocaleString("id-ID", {
                              style: "currency",
                              currency: "IDR",
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 0
                            })
                    }}
                  </label>
                  <span class="badge bg-success ms-0"></span>
                </a>

                <ul class="dropdown-menu rounded-2 border border-0 shadow dropdown-menu-end">
                  <li>
                    <NuxtLink to="/profile" class="dropdown-item"
                      >Akun Saya</NuxtLink
                    >
                  </li>
                  <li  v-if="userStore.user?.role === 'agld'">
                    <NuxtLink to="/subaccount" class="dropdown-item"
                      >Kelola Sub Akun</NuxtLink
                    >
                  </li>
                  <li v-if="show_markup">
                    <NuxtLink to="/markups/price" class="dropdown-item"
                      >Kelola Harga Markup</NuxtLink
                    >
                  </li>
                  <li>
                    <NuxtLink to="/security" class="dropdown-item"
                      >Pusat Keamanan</NuxtLink
                    >
                  </li>
                  <li>
                    <NuxtLink class="dropdown-item" to="/passengers/">
                      Kelola Data Penumpang
                    </NuxtLink>
                  </li>
                  <li><hr class="dropdown-divider" /></li>
                  <li>
                    <NuxtLink class="dropdown-item" to="/privacy-policy">
                      Privacy Policy
                    </NuxtLink>
                  </li>
                  <li>
                    <NuxtLink class="dropdown-item" to="/term-payments/">
                      Payment Policy
                    </NuxtLink>
                  </li>
                  <li><hr class="dropdown-divider" /></li>
                  <li style="cursor: pointer">
                    <p @click="clearCache" class="dropdown-item text-danger">Hapus Cache</P>
                  </li>
                  <li style="cursor:pointer">
                    <NuxtLink to="/delete-account" class="dropdown-item text-danger">Ajukan Penghapusan Akun</NuxtLink>
                  </li>
                  <li style="cursor: pointer">
                    <p @click="logoutConfirm" class="dropdown-item text-danger">Logout</p>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <!-- End Navbar -->
  </div>
</template>

<style scoped>
/* Default dropdown menu style */
.dropdown-menu ul {
  display: none;
  position: absolute;
  left: 100%;
  top: 0;
}

/* Show submenu on hover for desktop */
.dropdown-menu li:hover > ul {
  display: block;
}

/* Mobile dropdown submenu adjustment */
@media (max-width: 992px) {
  .dropdown-menu {
    position: static;
    float: none;
    width: 100%;
  }

  .dropdown-menu .dropdown-menu {
    position: relative;
    left: 0;
    top: 0;
    margin-top: 10px; /* Adjust space between submenus */
    display: none; /* Initially hidden */
  }

  /* Show submenu on click */
  .dropdown-menu.show .dropdown-menu {
    display: block;
  }
}



/* Memusatkan item di navbar saat di tampilan desktop */
.navbar-nav {
  display: flex;
  justify-content: center;
}

.navbar-nav.ms-auto.align-items-center {
  justify-content: flex-end;
}

@media (min-width: 992px) {
  .navbar-nav.ms-auto.fw-bolder {
    margin-left: auto;
    margin-right: auto;
  }
}

</style>
